import { http } from '../http'
import type { transcribeAudioData } from '@/types'

export function transcribeAudio(data: transcribeAudioData) {
	const formData = new FormData()
	formData.append('audio', data.audio, 'recording.webm')
	if (data.topic_id) {
		formData.append('topic_id', String(data.topic_id))
	}
	if (data.thread_id) {
		formData.append('thread_id', String(data.thread_id))
	}
	return http
		.post(`/transcribe-audio`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
		.then((response) => response.data)
}
